import {inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {NEVER, Observable, throwError} from 'rxjs';
import {AUTH_TOKEN_HTTP_CONTEXT} from '../constants/auth-token-http-context.constant';
import {catchError} from 'rxjs/operators';
import {TokenService} from '../services/token/token.service';
import {API_CONFIGS} from '../../configs/api.config';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private readonly tokenService = inject(TokenService);

    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const httpContextToken = request.context.get(AUTH_TOKEN_HTTP_CONTEXT);
        if (httpContextToken) {
            request = request.clone({ headers: request.headers.append('Authorization', 'Bearer ' + httpContextToken) });
        }

        //Bypass service worker
        request = request.clone({ headers: request.headers.append('ngsw-bypass', 'true') });

        //Workaround für die APIs, falls der Token vor eigentlichem Ablauf invalidiert wird (Server neustart)
        if (this.isApiRequest(request)) {
            return next.handle(request)
                .pipe(catchError(err => {
                    if (err.status === 401) {
                        if (this.tokenService.isCurrentTokenValid()) {
                            this.tokenService.invalidateToken();
                            console.warn('AuthInterceptor: token was rejected by the server before it expired, reloading the app.', err);
                            location.reload();
                            return NEVER;
                        }
                    }
                    return throwError(() => err);
                }));
        } else {
            return next.handle(request);
        }
    }

    private isApiRequest(request: HttpRequest<unknown>): boolean {
        return [
            API_CONFIGS.apis.internal.path,
            API_CONFIGS.apis.bfa.path,
        ].some(apiPath => request.url.includes('api/' + apiPath + '/'));
    }
}